<template lang="html">
  <div id="text-page">
    <div class="container med-container">
      <div class="col-12 col-s-title">
        <h1 class="title"><span>Información sobre colaboración en materia de seguridad y justicia</span></h1>
      </div>

      <div class="body">
        <p>En cumplimiento a lo establecido en los art&iacute;culos 189 y 190 de la Ley Federal de Telecomunicaciones y Radiodifusi&oacute;n, as&iacute; como en el Acuerdo mediante el cual el Pleno del Instituto Federal de Telecomunicaciones, expide los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia y sus modificaciones, se publica la informaci&oacute;n siguiente:</p>
<p>&nbsp;</p>
<ol>
<li><strong>&Aacute;rea Responsable:</strong></li>
</ol>
<ul>
<li>Departamento Legal</li>
</ul>
<p><strong>&nbsp;</strong></p>
<ol start="2">
<li><strong>Datos de Contacto:</strong></li>
</ol>
<ul>
<li>Domicilio: Calle Albino Espinosa Oriente n&uacute;mero 829, Colonia Monterrey Centro, Monterrey, Nuevo Le&oacute;n, C.P. 64000.</li>
<li>Correo Electr&oacute;nico: <a href="mailto:legal@blackfon.online">legal@blackfon.online</a></li>
<li>Tel&eacute;fono: 3336703680</li>
</ul>
<p>&nbsp;</p>
<ol start="3">
<li><strong>Para solicitudes de informaci&oacute;n, favor de mandarlas al siguiente:</strong></li>
</ol>
<ul>
<li>legal@blackfon.online</li>
</ul>
<p><strong>&nbsp;</strong></p>
<ol start="4">
<li><strong>Autoridades facultadas:</strong></li>
</ol>
<ul>
<li>Favor de contactar al &Aacute;rea Responsable para acreditar a sus autoridades designadas.</li>
</ul>
<p>&nbsp;</p>
<ol start="5">
<li><strong>Concesionaria:</strong></li>
</ol>
<ul>
<li>Alt&aacute;n Redes, S.A.P.I. de C.V.</li>
</ul>
      </div>

    </div>
  </div>
</template>

<script>
export default {
}
</script>
